<template>
  <article class="experience-tile h-100">
    <CardSurface pad="md" class="experience-tile__card h-100 d-flex flex-column">
      <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
        <span class="nm-chip">
          <i v-if="chipIcon" :class="chipIcon" class="experience-tile__chip-icon" aria-hidden="true" />
          {{ chip }}
        </span>
        <span class="experience-tile__status">{{ statusLabel }}</span>
      </div>

      <h3 class="experience-tile__title mb-2">{{ title }}</h3>
      <p class="experience-tile__body mb-3">{{ body }}</p>
      <p class="experience-tile__audience mt-auto mb-0">
        <i class="fa-solid fa-users experience-tile__audience-icon" aria-hidden="true" />
        {{ audience }}
      </p>

      <div class="experience-tile__preview mt-4">
        <div class="experience-tile__preview-inner">
          <i class="fa-solid fa-window-maximize experience-tile__preview-icon" aria-hidden="true" />
          <span>Interactive preview</span>
        </div>
      </div>
    </CardSurface>
  </article>
</template>

<script setup>
import CardSurface from '@/components/CardSurface.vue'

defineProps({
  chip: { type: String, required: true },
  chipIcon: { type: String, default: '' },
  title: { type: String, required: true },
  body: { type: String, required: true },
  audience: { type: String, required: true },
  statusLabel: { type: String, default: 'Coming soon' },
})
</script>

<style scoped>
.experience-tile__status {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: var(--nm-font-weight-semibold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nm-accent);
  padding: 0.35rem 0.65rem;
  border-radius: var(--nm-radius-pill);
  background: rgba(184, 180, 232, 0.1);
  border: 1px solid rgba(184, 180, 232, 0.2);
}

.experience-tile__chip-icon {
  margin-right: 0.35rem;
  font-size: 0.72rem;
}

.experience-tile__title {
  font-size: 1.15rem;
  font-weight: var(--nm-font-weight-semibold);
}

.experience-tile__body {
  font-size: 0.92rem;
  color: var(--nm-text-muted);
  line-height: 1.6;
}

.experience-tile__audience {
  font-size: 0.82rem;
  color: var(--nm-text-secondary);
}

.experience-tile__audience-icon {
  margin-right: 0.4rem;
  opacity: 0.7;
}

.experience-tile__preview {
  border-radius: var(--nm-radius-md);
  background: var(--nm-surface-inset);
  box-shadow: var(--nm-inset-sm);
  border: 1px dashed rgba(255, 255, 255, 0.08);
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.experience-tile__preview-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.78rem;
  font-weight: var(--nm-font-weight-medium);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nm-text-muted);
}

.experience-tile__preview-icon {
  font-size: 1.25rem;
  opacity: 0.5;
}
</style>